<template>
    <div class="apprentice-simple-card">
        <div class="description">
            {{ $t('group_pair.fill_in_below_which_columns_apply') }}
        </div>

        <div
            class="errors"
            v-if="hasErrors">
            <b-alert
                v-for="(error, index) in errors"
                v-if="error.error"
                show
                variant="danger"
                :key="`error-${index}`">
                {{ error.message }}
            </b-alert>
        </div>
        <b-form-group
            class="mapping-full-name-student"
            label-for="full-name-student-input"
            :label="$t('group_pair.full_name')">
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_full_name"
                :options="headings"></b-form-select>
        </b-form-group>
        <b-form-group
            class="mapping-first-name-student"
            label-for="first-name-student-input"
            :label="$t('common.first_name')">
            <template v-slot:label> {{ $t('common.first_name') }} <span class="required">*</span> </template>
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_first_name"
                :options="headings"></b-form-select>
        </b-form-group>
        <b-form-group
            class="mapping-preposition-student"
            label-for="preposition-student-input"
            :label="$t('common.infix')">
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_preposition"
                :options="headings"></b-form-select>
        </b-form-group>
        <b-form-group
            class="mapping-last-name-student"
            label-for="last-name-student-input"
            :label="$t('common.last_name')">
            <template v-slot:label> {{ $t('common.last_name') }} <span class="required">*</span> </template>
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_last_name"
                :options="headings"></b-form-select>
        </b-form-group>
        <b-form-group
            class="mapping-email-student"
            label-for="email-student-input"
            :label="$t('common.email_address')">
            <template v-slot:label> {{ $t('common.email_address') }} <span class="required">*</span> </template>
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_email"
                :options="headings"></b-form-select>
        </b-form-group>
        <b-form-group
            class="mapping-student-number"
            label-for="student-number-input"
            :label="$t('common.student_number')">
            <b-form-select
                class="apprentice-primary-select"
                v-model="settings.student_number"
                :options="headings"></b-form-select>
        </b-form-group>

        <button
            class="btn btn-outline-primary float-left btn-previous"
            type="button"
            @click="goBack">
            {{ $t('common.previous') }}
        </button>
        <b-button
            class="btn-save btn-save-school-settings"
            variant="primary"
            @click="saveSettings">
            {{ $t('common.save') }}
        </b-button>
        <!--        <group-import-component :settings-in="importIn" :group="groupIn"-->
        <!--                                :headings-in="headingsIn"></group-import-component>-->
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'design-2021-group-pair-import-mapping-component',
    props: ['groupIn', 'importIn', 'headingsIn'],
    data() {
        var headings = [];
        headings.push({ value: null, text: this.$t('group_pair.make_a_choice') });
        for (const [key, value] of Object.entries(this.headingsIn)) {
            headings.push({ value: key, text: value });
        }
        return {
            headings: headings,
            settings: {
                student_full_name: this.importIn.student_full_name,
                student_first_name: this.importIn.student_first_name,
                student_preposition: this.importIn.student_preposition,
                student_last_name: this.importIn.student_last_name,
                student_email: this.importIn.student_email,
                student_number: this.importIn.student_number,
            },
            hasErrors: false,
            errors: {
                first_name: {
                    error: false,
                    message: this.$t('group_pair.name_cannot_be_empty'),
                },
                last_name: {
                    error: false,
                    message: this.$t('group_pair.surname_cannot_be_empty'),
                },
                email: {
                    error: false,
                    message: this.$t('group_pair.email_cannot_be_empty'),
                },
            },
        };
    },
    methods: {
        goBack() {
            window.location.href = this.routes.groupPairImport(this.groupIn.id);
        },
        saveSettings() {
            if (this.errorsFound()) {
                $('.main-content').animate({ scrollTop: 0 }, 500);
                return;
            }

            //check content
            this.alert.saving();

            const uri = this.routes.groupPairImportSettings(this.groupIn.id, this.importIn.id);

            axios.post(this.routes.groupPairImportSettings(this.groupIn.id, this.importIn.id), this.settings).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.groupPairImportValidate(this.groupIn.id, this.importIn.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        errorsFound() {
            let foundErrors = false;
            this.hasErrors = false;
            this.errors.first_name.error = false;
            this.errors.last_name.error = false;
            this.errors.email.error = false;

            if (this.settings.student_first_name === null || this.settings.student_first_name === '') {
                foundErrors = true;
                this.hasErrors = true;
                this.errors.first_name.error = true;
            }

            if (this.settings.student_last_name === null || this.settings.student_last_name === '') {
                foundErrors = true;
                this.hasErrors = true;
                this.errors.last_name.error = true;
            }

            if (this.settings.student_email === null || this.settings.student_email === '') {
                foundErrors = true;
                this.hasErrors = true;
                this.errors.email.error = true;
            }

            return foundErrors;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.btn-previous {
    line-height: 1;
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
